import { IStackStyles } from "@fluentui/react";

export const notificationsContainerStyles: IStackStyles = {
    root: {
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        padding: '1rem',
        zIndex: 10,
        pointerEvents: 'none' // to allow the operation of controls underneath the notification container
    }
};
